import React from "react";
import { Link, useParams } from "react-router-dom";
import { Box, Button, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EnableDisableButton from "components/Shared/EnableDisableButton";

import { BASE_CONSTANTS } from "constants/baseConstants";

import {
  PaymentAccountDetailContext,
  usePaymentAccountDetailContext,
} from "contexts/PaymentContexts/PaymentAccountContext";

import {
  useGetPaymentAccountDetailQuery,
  useUpdatePaymentAccountMutation,
} from "store/services/PaymentsApi/paymentAccountApi";

import PaymentAccountBasicDetail from "./paymentAccountComponents/PaymentAccountBasicDetail";
import PaymentAccountDetailTab from "./paymentAccountComponents/PaymentAccountDetailTab";
import { useAuth } from "hooks";



const PaymentAccountDetailScreen = () => {
  const { id } = useParams();
  const { isVendor } = useAuth();

  const breadcrumbs = [
  { title: "Payment Account", path:!isVendor ? "/app/crm/payment-account/list" : "/app/vendor/payment-account/list"},
  { title: "Payment Account Detail" },
];

  const {
    data: paymentAccountDetail,
    isLoading: paymentAccountLoading,
    isFetching: paymentAccountFetching,
  } = useGetPaymentAccountDetailQuery(id);

  return (
    <PaymentAccountDetailContext.Provider value={{ paymentAccountDetail }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={paymentAccountLoading || paymentAccountFetching}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Paper>
          <PaymentAccountBasicDetail
            paymentAccountDetail={paymentAccountDetail}
            loadingPaymentAccount={
              paymentAccountLoading || paymentAccountFetching
            }
          />
          <Divider />
          <PaymentAccountDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </PaymentAccountDetailContext.Provider>
  );
};

const PageActions = () => {
  const { isVendor, isAccountAdmin } = useAuth();
  const { paymentAccountDetail } = usePaymentAccountDetailContext();

  // RTK Query
  const [updatePaymentAccount, { isLoading: updatingPaymentAccount }] =
    useUpdatePaymentAccountMutation();

  // methods
  const handleUpdatePaymentAccountStatus = async () => {
    try {
      await updatePaymentAccount({
        _id: paymentAccountDetail?._id,
        isActive: !paymentAccountDetail?.isActive,
      }).unwrap();
      toast.info(
        `PaymentAccount successfully ${
          paymentAccountDetail?.isActive ? "Disabled" : "Enabled"
        }!`
      );
    } catch (err) {
      toast.error(
        err?.data?.message ?? "Couldn't update PaymentAccount Status!"
      );
    }
  };

  return (
    <>
      {!isVendor && (
        <Box display="flex" gap={BASE_CONSTANTS.SPACING_SM}>
          {isAccountAdmin &&(
            <EnableDisableButton
              suffix="PaymentAccount"
              isActive={paymentAccountDetail?.isActive}
              loading={updatingPaymentAccount}
              onClick={handleUpdatePaymentAccountStatus}
            />
          )}

          <Link
            to={`/app/crm/payment-account/${paymentAccountDetail?._id}/edit`}
          >
            <Button variant="contained" startIcon={<EditOutlined />}>
              Edit
            </Button>
          </Link>
        </Box>
      )}
    </>
  );
};
export default PaymentAccountDetailScreen;
